import { Effect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WatchListActionTypes, WatchListActions, LoadWatchListSuccess, LoadWatchListFailure, DeleteWatchListItemSuccess, DeleteWatchListItemFailure, InsertWatchListItemFailure, InsertWatchListItemSuccess, LoadWatchList, DeleteWatchListItem, InsertWatchListItem } from '../actions/watchlist.actions';
import { WatchListService } from '../services/watch-list.service';
import { map, exhaustMap, catchError } from 'rxjs/operators';
import { WatchListItemNew } from '../models/watch-list.model';
import { of } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { CommonService } from '../services/common.service';

@Injectable()
export class WatchListEffects {
    @Effect()
    loadWatchList$: Observable<WatchListActions> = this.actions$.pipe(
        ofType(WatchListActionTypes.Load),
        exhaustMap(() => this.watchListService.getWatchList().pipe(
            map(products => new LoadWatchListSuccess(products)),
            catchError(error => of(new LoadWatchListFailure(error)))
        )),
    );

    @Effect()
    deleteWatchListItem$: Observable<WatchListActions> = this.actions$.pipe(
        ofType(WatchListActionTypes.Delete),
        exhaustMap((action:any) => this.watchListService.deleteWatchList(encodeURIComponent(action.payload)).pipe(
            map((response: ApiResponse) => {
                if (response.status) {
                    this.commonService.implementToast(response.responseMessage, "Success");
                    return new DeleteWatchListItemSuccess(action.payload);
                } else {
                    this.commonService.implementToast(response.responseMessage, "Error");
                    return new DeleteWatchListItemFailure();
                }
            }),
            catchError(error => of(new LoadWatchListFailure(error)))
        )),
    );

    @Effect()
    insertWatchListItem$: Observable<WatchListActions> = this.actions$.pipe(
        ofType(WatchListActionTypes.Insert),
        exhaustMap((action:any) => this.watchListService.insertWatchList([action.payload.out_stock_code]).pipe(
            map((response: ApiResponse) => {

                if (response.status) {

                    const newItem = action.payload as WatchListItemNew;
                    this.commonService.implementToast(response.responseMessage, 'Success');
                    return new InsertWatchListItemSuccess(newItem);
                    //return new LoadWatchList();

                } else {
                    this.commonService.implementToast(response.responseMessage, 'Error');
                    return new InsertWatchListItemFailure();
                }

            })
        ))
    )


    constructor(
        private actions$: Actions,
        private watchListService: WatchListService,
        private commonService: CommonService
    ) { }
}